export default {
  data: ()=>({
    loading: true,
    loginPopup: false,
    loginError: null,
    mode: 'login',
    loginForm: {
      username: null,
      password: null,
    },
    themeData: window.themeData,
  }),
  computed: {
    loggedInUser() {
      return this.stores.config.user;
    }
  },
  methods: {
    async getLoggedIn() {
      var result=await appPubApi.root();
      this.loading=false;
      this.stores.config.setUser(result.user);
    },
    async doLogout() {
      appPubApi.setAuth(null);
      this.stores.config.setUser(null);
      localStorage.removeItem("icCartUuid");
      appCartWidget.loadCart();
    },
    async doLogin() {
      if (this.mode=='login') {
        this.loginError=null;
        var formData={...this.loginForm};
        delete formData.username;
        var result=await appPubApi.login(this.loginForm.username, formData);
        if (result.error)
          this.loginError=result.error;
        if (result.token) {
          appPubApi.setAuth(result.token);
          await this.getLoggedIn();
          this.loginPopup=false;
          appCartWidget.loadCart();
        }
      } else if (this.mode=='forgot') {
        this.loginError=null;
        var formData={...this.loginForm};
        delete formData.username;
        var result=await appPubApi.doAction("Profile", "00000000-0000-0000-0000-000000000000", {action: "forgotPassword", username: this.loginForm.username});
        if (result.error)
          this.loginError=result.error;
        else
          this.mode="forgot2";
      }
    },
    showForgot() {
      this.mode="forgot";
    },
    showLogin() {
      this.mode="login";
    },
  },
  created() {
    window.appUserWidget=this;
    this.getLoggedIn();
  },
}
